<template>
  <Modal :isVisible="true">
    <div class="grid grid-cols-12 gap-6 p-4">
      <div class="max-w-xs col-span-5 border rounded-xl overflow-hidden shadow">
        <div class="w-full rounded-xl overflow-hidden" v-if="data.placement">
          <img
            :src="data.media_source"
            alt=""
            class="w-full"
            v-if="
              data.media_source.includes('.png') ||
                data.media_source.includes('.jpg')
            "
          />
          <video
            class="w-full"
            controls
            :src="data.media_source"
            v-if="data.media_source.includes('.mp4')"
          ></video>
        </div>
        <Post :data="data" v-else />
      </div>
      <div class="grid grid-rows-6 col-span-7">
        <div class="row-span-5 pt-6">
          <p class="text-lg">{{ data.analysis }}</p>
        </div>
        <div
          class="row-span-1 grid grid-flow-col justify-end justify-items-end content-center items-center gap-4"
        >
          <!-- <router-link :to="`/ads/${prevIdAd}`">
            <button
              type="button"
              class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              @click="state = false"
            >
              <Icon name="ArrowNarrowLeft" class="w-6" />
            </button>
          </router-link>
          <router-link :to="`/ads/${nextIdAd}`">
            <Button>
              <Icon name="ArrowNarrowRight" class="w-6" />
            </Button>
          </router-link> -->
          <router-link to="/">
            <Button>
              <Icon name="Close" class="w-6" />
            </Button>
          </router-link>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import Modal from "@/components/UI/Modal";
import Icon from "@/components/UI/Icon";
import Post from "@/components/Ad/Post";
import Button from "@/components/UI/Button";

export default {
  components: { Modal, Icon, Post, Button },
  props: {
    isVisible: Boolean,
    data: Object,
  },
  setup() {
    const store = useStore();

    const prevIdAd = computed(() => store.state.prevIdAd);
    const nextIdAd = computed(() => store.state.nextIdAd);

    return { prevIdAd, nextIdAd };
  },
};
</script>

<style></style>
